import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "raffleManageFill" }

import {basicFormConfig} from "./config/form.config";
import {ref} from "vue";
import BasicForm from "@/components/BasicForm.vue";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const closePage = () => {
  window.close()
}

const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value = route.query
console.log(route.query)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BasicForm, {
      basicFormConfig: _unref(basicFormConfig),
      "col-layout": {xl: 12,lg: 12,md: 12,sm: 12,xs: 12},
      pageName: "raffleManage",
      defaultInfo: defaultInfo.value,
      onClosePage: closePage
    }, null, 8, ["basicFormConfig", "defaultInfo"])
  ]))
}
}

})